import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  count?: number[];
  dates?: string[];
}

export const useTasksCountOverTime = (): ChartProps => {
  const { t } = useLang();
  const { list } = useDashboardStore();
  const data = list?.total_tasks_in_time as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data) {
      return {
        series: data.count?.length
          ? [
              {
                name: t('Кол-во задач'),
                data: data.count,
              },
            ]
          : [],
        options: {
          chart: {
            type: 'area',
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 5,
          },
          title: {
            text: t('Кол-во задач'),
            align: 'left',
          },
          xaxis: {
            categories: data.dates,
            tickAmount: 10,
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            opposite: true,
          },
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [t, data]);

  return {
    series: chartData.series,
    options: chartData.options,
    label: 'Общее количество созданных задач по времени',
    subLabel:
      'Диаграмма показывает динамику общего числа созданных задач за выбранный период, помогая отследить рост или спад нагрузки',
    type: 'area',
    wrapped: true,
  };
};
